import { NavLink } from 'react-router-dom'
import { ReactNode, useMemo } from 'react'
import { logout } from '../utils/auth'

interface LayoutProps {
  children?: ReactNode
  isOwner?: boolean
}

function Layout({ children, isOwner = false }: LayoutProps) {
  const user = useMemo(() => {
    const fallbackId = localStorage.getItem('okr_userId') || ''
    const raw = localStorage.getItem('okr_userInfo')
    if (!raw) return { name: fallbackId || '未登录用户', userId: fallbackId }

    try {
      const parsed = JSON.parse(raw)
      return {
        name: parsed.name || parsed.UserId || parsed.userId || fallbackId || '企业微信用户',
        userId: parsed.UserId || parsed.userId || fallbackId
      }
    } catch {
      return { name: fallbackId || '企业微信用户', userId: fallbackId }
    }
  }, [])


  return (
    <div className="app-shell">
      <aside className="sidebar-card">
        <div className="brand-block">
          <span className="brand-dot" />
          <div>
            <h1>团队目标管理系统</h1>
            <p>信息管理部 · 执行与复盘一体化</p>
          </div>
        </div>

        <div className="user-panel">
          <span className="section-kicker">当前登录</span>
          <strong>{user.name}</strong>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/">仪表盘</NavLink>
          <NavLink to="/goals">目标管理</NavLink>
          <NavLink to="/worklogs">工作日志</NavLink>
          <NavLink to="/reports">报告中心</NavLink>
          {isOwner && <NavLink to="/settings">系统设置</NavLink>}
          {isOwner && <NavLink to="/admin">后台管理</NavLink>}
        </nav>

        <button className="secondary-btn logout-wide" onClick={logout}>退出登录</button>
      </aside>

      <div className="content-shell">
        <main className="main-panel">{children}</main>
        <footer className="footer">
          <p>© 2026 信息管理部 - 目标管理系统 v1.0</p>
        </footer>
      </div>
    </div>
  )
}

export default Layout
